<template>
  <div>
    <div>
      <b-row v-if="!isMobile()">
        <vs-card style="width: 60%">
          <b-row>
            <teklif-onay-mail-gonder
              ref="invoiceRef"
              :paramsData="itemParam[0]"
              :tarih="TARIH"
            >
              <template slot="action-buttons">
                <table style="width: 100%" class="border-collapse">
                  <tr>
                    <td>
                      <h5 style="text-align: start">
                        {{ ACTNAME }}
                      </h5>
                      <h6 style="text-align: start">
                        {{ DESCRIPTION }}
                      </h6>
                    </td>
                    <td style="padding: 10px; text-align: right">
                      <p style="font-size: 18px">Tarih: {{ TARIH }}</p>
                      <p style="font-size: 18px">
                        Sıra No: {{ $route.params.DOCUMENTNO }}
                      </p>
                    </td>
                  </tr>
                </table>

                <table
                  border="1"
                  style="border-top: 1px solid grey; width: 100%"
                  class="border-collapse"
                >
                  <tr>
                    <td>
                      <table style="width: 100% !important; text-align: center">
                        <tr>
                          <th
                            sort-key="stokkodu"
                            style="
                              text-align: center;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            RESIM
                          </th>

                          <th
                            style="
                              text-align: center;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            STOK NO
                          </th>
                          <th
                            style="
                              text-align: center;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            STOK ADI
                          </th>
                          <th
                            style="
                              text-align: center;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            AÇIKLAMA
                          </th>
                          <th
                            style="
                              text-align: center;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            MİKTAR
                          </th>
                          <th
                            style="
                              text-align: center;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            FİYAT
                          </th>
                          <th
                            style="
                              text-align: center;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            TUTAR
                          </th>
                        </tr>

                        <tr :key="indextr" v-for="(tr, indextr) in itemListele">
                          <td style="padding: 8px">
                            <img
                              :src="resimYazdir(tr.RESIM)"
                              alt=""
                              style="width: 80px"
                            />
                          </td>

                          <td style="padding: 8px">
                            {{ tr.STOCKNO }}
                          </td>
                          <td style="padding: 8px">
                            {{ tr.STOCKNAME }}
                          </td>
                          <td style="padding: 8px">
                            {{ tr.DESCRIPTION }}
                          </td>
                          <td style="padding: 8px">{{ tr.QUANTITY }}</td>
                          <td style="padding: 8px">
                            {{ currencyFormatter(tr.CURRPRICE, tr.CURRCODE) }}
                          </td>
                          <td style="padding: 8px">
                            {{ currencyFormatter(tr.CURRTOTAL, tr.CURRCODE) }}
                          </td>
                        </tr>
                        <tr>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>

                          <td style="padding: 8px"></td>
                          <td style="font-weight: bold; padding: 8px">Ara Toplam:</td>
                          <td style="font-weight: bold; padding: 8px">
                            {{ currencyFormatter(araToplam, CURRCODE) }}
                          </td>
                        </tr>
                        <tr>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>

                          <td style="padding: 8px"></td>
                          <td style="font-weight: bold; padding: 8px">Kdv Toplam:</td>
                          <td style="font-weight: bold; padding: 8px">
                            {{ currencyFormatter(kdvToplam, CURRCODE) }}
                          </td>
                        </tr>
                        <tr>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>
                          <td style="padding: 8px"></td>

                          <td style="font-weight: bold; padding: 8px">Gn Toplam:</td>
                          <td style="font-weight: bold; padding: 8px">
                            {{ currencyFormatter(gnToplam, CURRCODE) }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <br />
                </table>

                <br />
                <table style="width: 100%" class="border-collapse">
                  <tr>
                    <td style="padding: 10px; text-align: left">
                      <p class="text-primary" style="font-size: 15px; font-weight: bold">
                        ÖDEME ŞEKLİ :<span style="font-weight: 500; color: black">{{
                          odemeSekli
                        }}</span>
                      </p>
                      <p class="text-primary" style="font-size: 15px; font-weight: bold">
                        SEVK ŞEKLİ :<span style="font-weight: 500; color: black">{{
                          sevkSekli
                        }}</span>
                      </p>
                      <p class="text-primary" style="font-size: 15px; font-weight: bold">
                        NOTLAR :
                        <span style="font-weight: 500; color: black">{{ notlar }}</span>
                      </p>
                      <p>
                        Döviz fiyatları, teklifin kabulu halinde, fatura tarihinden bir
                        önceki günkü merkez bankası satış kurundan faturalandırılacaktır.
                      </p>
                      <p class="text-primary" style="font-size: 15px; font-weight: bold">
                        Teklifi Hazırlayan :
                        <span style="font-weight: 500; color: black">{{
                          teklifiHazirlayan
                        }}</span>
                      </p>
                      <p class="text-primary" style="font-size: 15px; font-weight: bold">
                        Teslimat Adresi :
                        <span style="font-weight: 500; color: black"
                        >{{ adresTipi }}:{{ adres }}</span
                      >
                      </p>
                    </td>
                  </tr>
                </table>

                <br />
                <div style="height: 150px">
                  <table style="width: 100%">
                    <tr>
                      <td style="text-align: center; padding: 3px; font-weight: bold">
                        Gönderici Onayı
                      </td>
                      <td style="text-align: center; padding: 3px; font-weight: bold">
                        Whatsapp Alıcı Onayı
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          text-align: center;

                          padding: 3px;
                        "
                      >
                        DENİZLİ CANER LTD.
                      </td>
                      <td style="text-align: center; padding: 3px">
                        <p>{{ ACTNAME }}</p>
                        <p>{{ onayAdi }}</p>
                        <p>{{ onaylayan }}</p>
                        <p>{{ ipAdres }}</p>
                      </td>
                    </tr>
                  </table>
                </div>
                <!--
                <table
                  v-if="GridOnayValidate == false"
                  border="1"
                  style="border-top: 1px solid grey; width: 100%"
                  class="border-collapse"
                >
                  <tr>
                    <td>
                      <table style="width: 100% !important; text-align: center">
                        <tr>
                          <th
                            sort-key="stokkodu"
                            style="
                        text-align: center;
                        border-bottom: 1px solid grey;
                        padding: 3px;
                      "
                          >
                            GÖNDERİ TARİHİ
                          </th>

                          <th
                            style="
                        text-align: center;
                        border-bottom: 1px solid grey;
                        padding: 3px;
                      "
                          >
                            ALICI
                          </th>
                          <th
                            style="
                        text-align: center;
                        border-bottom: 1px solid grey;
                        padding: 3px;
                      "
                          >
                            GÖNDERİ TÜRÜ
                          </th>
                          <th
                            style="
                        text-align: center;
                        border-bottom: 1px solid grey;
                        padding: 3px;
                      "
                          >
                            GÖNDEREN PERSONEL
                          </th>
                          <th
                            style="
                        text-align: center;
                        border-bottom: 1px solid grey;
                        padding: 3px;
                      "
                          >
                            ONAY TARİHİ
                          </th>
                        </tr>

                        <tr
                          :key="indextr"
                          v-for="(tr, indextr) in itemListGorev"
                        >
                          <td style="padding: 8px">
                            {{ parseDate(tr.GONDERITARIH) }}
                          </td>

                          <td style="padding: 8px">
                            {{ tr.ALICI }}
                          </td>
                          <td style="padding: 8px">
                            {{ tr.GONDERITUR }}
                          </td>
                          <td style="padding: 8px">{{ tr.GONDEREN }}</td>
                          <td style="padding: 8px">
                            {{ tr.ONAYTARIH }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <br />
                </table>-->

                <div v-if="DivOnayValidate == true">
                  <vs-card>
                    <b-row style="margin-bottom: 10px" align-h="end">
                      <b-col cols="3"></b-col>

                      <b-col>
                        <vs-checkbox
                          v-model="onayCheck"
                          style="font-size: 25px; text-align: center"
                        >
                          Teklifi Kabul Ediyorum. İşlemi Onaylıyorum</vs-checkbox
                        ></b-col
                      >
                      <b-col cols="2"></b-col>
                    </b-row>
                    <b-row>
                      <b-col></b-col>
                      <b-col>
                        <vs-button
                          style="border-radius: 5px; width: 100%"
                          type="gradient"
                          id="button-with-loading-yeni"
                          class="vs-con-loading__container"
                          size=""
                          @click="onayla()"
                          >Onayla</vs-button
                        >
                      </b-col>
                      <b-col></b-col>
                    </b-row>
                  </vs-card>
                </div>
                <div>
                  <h6>
                    TEKLİFİ ONAYLADIYSANIZ, LÜTFEN YAZDIRIP, KAŞE VE İMZAYLA 258-2512943
                    NOLU TELEFONA FAKSLAYINIZ.
                  </h6>
                </div>
              </template>
            </teklif-onay-mail-gonder>
          </b-row>
        </vs-card>
      </b-row>
      <b-row v-else>
        <vs-card>
          <b-row>
            <teklif-onay-mail-gonder
              ref="invoiceRef"
              :paramsData="itemParam[0]"
              :tarih="TARIH"
            >
              <template slot="action-buttons">
                <table style="width: 100%" class="border-collapse">
                  <tr>
                    <td>
                      <h5 style="text-align: start">
                        {{ ACTNAME }}
                      </h5>
                      <h6 style="text-align: start">
                        {{ DESCRIPTION }}
                      </h6>
                    </td>
                    <td style="padding: 10px; text-align: right">
                      <p style="font-size: 18px">Tarih: {{ TARIH }}</p>
                      <p style="font-size: 18px">
                        Sıra No: {{ $route.params.DOCUMENTNO }}
                      </p>
                    </td>
                  </tr>
                </table>

                <b-row>
                  <b-col>
                    <table
                      border="1"
                      style="border-top: 1px solid grey; width: 100%"
                      class="border-collapse"
                    >
                      <tr>
                        <td>
                          <table style="width: 100% !important; text-align: center">
                            <tr>
                              <th
                                sort-key="stokkodu"
                                style="
                                  text-align: center;
                                  border-bottom: 1px solid grey;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                RESIM
                              </th>

                              <th
                                style="
                                  text-align: center;
                                  border-bottom: 1px solid grey;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                STOK NO
                              </th>
                              <th
                                style="
                                  text-align: center;
                                  border-bottom: 1px solid grey;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                STOK ADI
                              </th>
                              <th
                                style="
                                  text-align: center;
                                  border-bottom: 1px solid grey;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                MİKTAR
                              </th>
                              <th
                                style="
                                  text-align: center;
                                  border-bottom: 1px solid grey;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                FİYAT
                              </th>
                              <th
                                style="
                                  text-align: center;
                                  border-bottom: 1px solid grey;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                TUTAR
                              </th>
                            </tr>

                            <tr :key="indextr" v-for="(tr, indextr) in itemListele">
                              <td style="padding: 3px">
                                <img
                                  :src="resimYazdir(tr.RESIM)"
                                  alt=""
                                  style="width: 30px"
                                />
                              </td>

                              <td style="padding: 3px; font-size: 10px !important">
                                {{ tr.STOCKNO }}
                              </td>
                              <td style="padding: 3px; font-size: 10px !important">
                                {{ tr.STOCKNAME }}
                              </td>
                              <td style="padding: 8px">
                                {{ tr.DESCRIPTION }}
                              </td>
                              <td style="padding: 3px; font-size: 10px !important">
                                {{ tr.QUANTITY }}
                              </td>
                              <td style="padding: 3px; font-size: 10px !important">
                                {{ currencyFormatter(tr.CURRPRICE, tr.CURRCODE) }}
                              </td>
                              <td style="padding: 3px; font-size: 10px !important">
                                {{ currencyFormatter(tr.CURRTOTAL, tr.CURRCODE) }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 3px"></td>
                              <td style="padding: 8px"></td>

                              <td style="padding: 3px"></td>
                              <td style="padding: 3px"></td>
                              <td style="padding: 3px"></td>
                              <td
                                style="
                                  font-weight: bold;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                Ara Toplam:
                              </td>
                              <td
                                style="
                                  font-weight: bold;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                {{ currencyFormatter(araToplam, CURRCODE) }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 3px"></td>
                              <td style="padding: 8px"></td>

                              <td style="padding: 3px"></td>
                              <td style="padding: 3px"></td>
                              <td style="padding: 3px"></td>
                              <td
                                style="
                                  font-weight: bold;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                Kdv Toplam:
                              </td>
                              <td
                                style="
                                  font-weight: bold;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                {{ currencyFormatter(kdvToplam, CURRCODE) }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 8px"></td>

                              <td style="padding: 3px"></td>
                              <td style="padding: 3px"></td>
                              <td style="padding: 3px"></td>
                              <td style="padding: 3px"></td>
                              <td
                                style="
                                  font-weight: bold;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                Gn Toplam:
                              </td>
                              <td
                                style="
                                  font-weight: bold;
                                  padding: 3px;
                                  font-size: 10px !important;
                                "
                              >
                                {{ currencyFormatter(gnToplam, CURRCODE) }}
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <br />
                    </table>
                  </b-col>
                </b-row>

                <br />
                <table style="width: 100%" class="border-collapse">
                  <tr>
                    <td style="padding: 10px; text-align: left">
                      <p class="text-primary" style="font-size: 15px; font-weight: bold">
                        ÖDEME ŞEKLİ :<span style="font-weight: 500; color: black">{{
                          odemeSekli
                        }}</span>
                      </p>
                      <p class="text-primary" style="font-size: 15px; font-weight: bold">
                        SEVK ŞEKLİ :<span style="font-weight: 500; color: black">{{
                          sevkSekli
                        }}</span>
                      </p>
                      <p class="text-primary" style="font-size: 15px; font-weight: bold">
                        NOTLAR :
                        <span style="font-weight: 500; color: black">{{ notlar }}</span>
                      </p>
                    </td>
                  </tr>
                </table>

                <br />
                <div style="height: 150px">
                  <table style="width: 100%">
                    <tr>
                      <td style="text-align: center; padding: 3px; font-weight: bold">
                        Gönderici Onayı
                      </td>
                      <td style="text-align: center; padding: 3px; font-weight: bold">
                        Whatsapp Onayı Alıcı
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          text-align: center;

                          padding: 3px;
                        "
                      >
                        DENİZLİ CANER LTD.
                      </td>
                      <td style="text-align: center; padding: 3px">
                        <p>{{ ACTNAME }}</p>
                        <p>{{ onayAdi }}</p>
                        <p>{{ onaylayan }}</p>
                        <p>{{ ipAdres }}</p>
                      </td>
                    </tr>
                  </table>
                </div>

                <div v-if="DivOnayValidate == true">
                  <vs-card>
                    <b-row style="margin-bottom: 10px" align-h="end">
                      <b-col cols="3"></b-col>

                      <b-col>
                        <vs-checkbox
                          v-model="onayCheck"
                          style="font-size: 25px; text-align: center"
                        >
                          Teklifi Kabul Ediyorum. İşlemi Onaylıyorum</vs-checkbox
                        ></b-col
                      >
                      <b-col cols="2"></b-col>
                    </b-row>
                    <b-row>
                      <b-col></b-col>
                      <b-col>
                        <vs-button
                          style="border-radius: 5px; width: 100%"
                          type="gradient"
                          id="button-with-loading-yeni"
                          class="vs-con-loading__container"
                          size=""
                          @click="onayla()"
                          >Onayla</vs-button
                        >
                      </b-col>
                      <b-col></b-col>
                    </b-row>
                  </vs-card>
                </div>
                <div>
                  <h6>
                    TEKLİFİ ONAYLADIYSANIZ, LÜTFEN YAZDIRIP, KAŞE VE İMZAYLA 258-2512943
                    NOLU TELEFONA FAKSLAYINIZ.
                  </h6>
                </div>
              </template>
            </teklif-onay-mail-gonder>
          </b-row>
        </vs-card>
      </b-row>
    </div>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import userJson from "../../../public/user.json";
import moment from "moment";
import Store from "../../store/store";
import state from "../../store/state";
import { Icon } from "@iconify/vue2";
import { BDropdown, BDropdownItem, VBTooltip } from "bootstrap-vue";
import TeklifOnayMailGonder from "../components/crm-components/satis-components/TeklifOnayMailGonder.vue";
export default {
  metaInfo() {
    return {
      title: "Caner Group",
      meta: [
        {
          name: "Bu ileti Caner Group tarafından gönderilen, teklif onayı içindir. ",
          content: "İşlemi onaylıyorum kısmına tıklayıp, onayla butonuna basınız.",
        },
      ],
    };
  },
  props: ["gelenDeger"],
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      CURRCODE: "",
      onayCheck: false,
      itemParam: [],
      promtBaslik: "",
      activePrompt: false,
      toplamTutar: 0.0,
      teklifOnayListDetay: [],
      itemListele: [],
      itemListGorev: [],

      ipAdres: "",
      TARIH: "",
      aciklama: "",
      ACTNAME: "",
      DESCRIPTION: "",
      odemeSekli: "",
      teklifiHazirlayan: "",
      adres: "",
      adresTipi: "",

      sevkSekli: "",
      notlar: "",
      onayAdi: "",
      cariAdi1: "",
      onaylayan: "",
      NotesId: "",
      araToplam: 0.0,
      kdvToplam: 0.0,
      gnToplam: 0.0,
      onay: "",
      mail: "",
      Panel1Validate: false,
      GridOnayValidate: false,
      DivOnayValidate: false,

      imgSrcUrl: "https://servis.kamyonyedekparca.com",
      cariList: [],
    };
  },
  components: { Icon, TeklifOnayMailGonder },
  methods: {
    isMobile: function () {
      return isMobile;
    },
    mailGonder() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = userJson.userService;
      var args = {};
      let receiver =
        typeof vm.$route.params.EMAIL == "undefined"
          ? "info@kamyonyedekparca.com"
          : vm.$route.params.EMAIL;
      console.log(receiver);
      args = {
        ALICI: receiver,
        MESAJ:
          " Onay talep edilen işlem onaylanmıştır " +
          "<br /><table cellpadding='1' cellspacing='1'  style='width: 500px;' border='1'>" +
          "<tr> <td  style='width: 200px;'> Firma  </td> <td style='width: 300px;' >" +
          vm.ACTNAME +
          "</td> </tr>" +
          "<tr> <td style='width: 200px;'> Teklif Tarihi </td> <td style='width: 300px;'>" +
          vm.TARIH +
          "</td> </tr>" +
          "<tr> <td style='width: 200px;'> Teklif No </td> <td style='width: 300px;'>" +
          vm.$route.params.DOCUMENTNO +
          "</td> </tr>" +
          "<tr> <td style='width: 200px;'> Tutar </td> <td style='width: 300px;'>" +
          vm.gnToplam +
          "</td> </tr>" +
          "<tr> <td style='width: 200px;'> Teklif Notu </td> <td style='width: 300px;'>" +
          vm.notlar +
          "</td> </tr>" +
          "</table>",
        KONU: "Teklif Onay",
      };
      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          if (result.mailGonderResult == "-1") {
            //  Store.dispatch("logout");
            //vm.$store.dispatch('login', payload)
          }
          let veriler2 = JSON.parse(result.mailGonderResult);
          try {
            console.log(veriler2.response);
            if (veriler2.response == "Ok") {
              vs.notify({
                title: "Mail",
                text: "Mail başarıyla gönderildi." + veriler2.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }
          } catch (error) {
            console.log(error);
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu." + veriler2.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    onayla() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = userJson.userService;
      const args = {
        token: Store.state.tokenId,
        ID: vm.itemParam[0].ID,
      };
      console.log(args);
      if (vm.onayCheck == true) {
        soap.createClient(url, function (err, client) {
          client.INT_LS_TEKLIF_ONAYLA(args, function (err, result) {
            if (result.INT_LS_TEKLIF_ONAYLAResult == "0") {
              //  Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAYLAResult);
              //  vm.itemListGorev = JSON.parse(vm.veriler.jsonData);
              console.log(vm.veriler);
              vs.notify({
                title: "Teklif Onay",
                text: "Teklif onaylandı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              vm.mailGonder();
              vm.detayaGit();
            } catch (error) {
              console.log(error);
            }
          });
        });
      } else {
        vs.notify({
          title: "Teklif Onay",
          text: "Teklif onayını işaretleyiniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
    resimYazdir(url) {
      var changedPicture = url;
      if (url.toString().includes("~") == true) {
        changedPicture = url.toString().replace("~", "");
      }
      this.imgSrc = this.imgSrcUrl + changedPicture;
      return this.imgSrc;
    },
    parseDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },
    currencyFormatter(currency, sign) {
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${formatted} ` + sign;
    },

    getDetayOnayList() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = userJson.userService;
      const args = {
        token: Store.state.tokenId,
        RECEIPTID: vm.itemParam[0].ID,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_DETAY_ONAY(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_DETAY_ONAYResult == "0") {
            //  Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_DETAY_ONAYResult);
            vm.itemListGorev = JSON.parse(vm.veriler.jsonData);
            console.log(vm.itemListGorev);
          } catch (error) {
            console.log(error);
          }
        });
      });
    },

    getDetayList() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = userJson.userService;
      const args = {
        token: Store.state.tokenId,
        ID: vm.itemParam[0].ID,
        TRANSTYPE: vm.itemParam[0].TRANSTYPE,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_DETAY_LIST(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_DETAY_LISTResult == "0") {
            //  Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_DETAY_LISTResult);
            vm.itemListele = JSON.parse(vm.veriler.jsonData);
            vm.CURRCODE = vm.itemListele[0].CURRCODE;
            console.log(vm.itemListele);
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    detayaGit() {
      var vm = this;
      console.log(vm.itemParam[0]);
      vm.getDetayList();
      vm.getDetayOnayList();
      const vs = this.$vs;

      const soap = require("soap");
      const url = userJson.userService;
      const args = {
        token: Store.state.tokenId,
        ID: vm.itemParam[0].ID,
        TRANSTYPE: vm.itemParam[0].TRANSTYPE,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_DETAY(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_DETAYResult == "0") {
            // Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_DETAYResult);

            let list = JSON.parse(vm.veriler.jsonData);
            console.log(list);
            vm.sevkSekli = list[0].DESCRIPTION2;
            vm.odemeSekli = "Fatura tarihinden itibaren " + list[0].DUEDAY + " gündür";
            vm.ipAdres = list[0].IP;
            vm.TARIH = list[0].TARIH;
            vm.aciklama = list[0].DESCRIPTION;
            vm.ACTNAME = list[0].ACTNAME;
            vm.DESCRIPTION = list[0].DESCRIPTION;
            vm.onayAdi = list[0].CHECKMD5SUM;
            vm.cariAdi1 = list[0].ACTNAME;
            vm.onaylayan = list[0].NAME2;
            vm.NotesId = list[0].NOTEID;
            vm.araToplam = list[0].NETTOPLAM;
            vm.kdvToplam = list[0].VATSUM;
            vm.gnToplam = list[0].TOTAL;
            vm.onay = list[0].APPROVE3;
            vm.mail = list[0].MAIL;
            vm.teklifiHazirlayan = vm.itemParam[0].EMPLOYEENAME;
            vm.adres = list[0].ADRES;
            vm.adresTipi = list[0].ADRESBASLIK;

            console.log(vm.onay);

            let LblGelenId = "",
              LblTur = "",
              LblCode = "",
              LblAp = "1";
            let sayiBul, RecBul;
            let Gelen = vm.itemParam[0].ID.split("");
            console.log(Gelen.indexOf("-"));
            if (Gelen.includes("CCC") == true)
              sayiBul = parseInt(Gelen.indexOf("CCC=").toString());
            if (Gelen.includes("-") == true)
              RecBul = parseInt(Gelen.indexOf("-").toString());
            let GelenUzunluk = vm.itemParam[0].ID.Length;

            if (GelenUzunluk > 12) {
              LblGelenId = vm.itemParam[0].ID.substring(4, sayiBul - RecBul - 1);
              LblTur = vm.itemParam[0].ID.substring(0, 3);
              LblCode = vm.itemParam[0].ID.substring(
                sayiBul,
                GelenUzunluk - sayiBul
              ).replace("CCC=", "");
              LblAp = "0";
            } else {
              LblGelenId = vm.itemParam[0].ID.substring(4, vm.itemParam[0].ID.Length - 4);
              LblTur = vm.itemParam[0].TRANSTYPE.toString();
              LblAp = "1";
            }
            console.log(LblAp);
            if (vm.onay == true || vm.onay == "True") {
              //|| LblAp == "1"
              vm.Panel1Validate = true;
              vm.GridOnayValidate = true;
              vm.DivOnayValidate = false;
              //Detay();
              //OnayListe();
            } else {
              vm.DivOnayValidate = true;
              vm.GridOnayValidate = false;
            }
            vm.DivOnayValidate;

            const args2 = {
              token: Store.state.tokenId,
              NotesId: vm.NotesId,
            };
            console.log(args2);
            soap.createClient(url, function (err, client) {
              client.INT_LS_TEKLIF_ONAY_NOTLAR(args2, function (err, result) {
                if (result.INT_LS_TEKLIF_ONAY_NOTLARResult == "0") {
                  //  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                try {
                  vm.veriler2 = JSON.parse(result.INT_LS_TEKLIF_ONAY_NOTLARResult);

                  let list2 = JSON.parse(vm.veriler2.jsonData);
                  console.log(list2);
                  vm.notlar = list2[0].NOTES;
                } catch (error) {
                  console.log(error);
                }
              });
            });
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
  },
  created() {
    const data = [];

    data["servisAdresi"] = localStorage.getItem("servisAdresi");
    data["id"] = localStorage.getItem("id");
    data["employeeid"] = localStorage.getItem("employeeid");
    data["firmaAdi"] = localStorage.getItem("firmaAdi");

    data["tokenId"] = localStorage.getItem("tokenId");

    data["COMPANYID"] = localStorage.getItem("COMPANYID");
    data["EMPLOYEENO"] = localStorage.getItem("EMPLOYEENO");
    data["EMAIL"] = localStorage.getItem("EMAIL");
    data["USERLONGNAME"] = localStorage.getItem("USERLONGNAME");
    // var result = localStorage.getItem("tokenId").substring(1, 7);
    //  data["mailCode"] = localStorage.getItem("mailCode");
    data["GROUPCODE"] = localStorage.getItem("GROUPCODE");

    this.$store.commit("setToken", data);

    this.itemParam.push({
      ID: this.$route.params.ID,
      TRANSTYPE: this.$route.params.TRANSTYPE,
      DOCUMENTNO: this.$route.params.DOCUMENTNO,
      EMAIL: this.$route.params.EMAIL,
    });
    console.log(this.itemParam);
    this.detayaGit();
  },
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.rag-amber {
  background-color: lightsalmon;
}

.rag-blue {
  background-color: lightblue;
}

.rag-green {
  background-color: lightgreen;
}

.con-vs-dialog {
  z-index: 52005555;
}

[dir] .vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0.5rem !important;
}
</style>
